import { api } from '@cwd/lib/main';

export interface ErrorQueueSummary {
    Name: string;
    Messages: number;
}

export interface RabbitMessage {
    MessageId: string;
    MessageType: string | null;
    ShortMessageType: string | null;
    SourceQueue: string | null;
    ErrorSummary: string | null;
    Body: string | null;
    Headers: Record<string, string>;
}

export interface MessageTypeGroup {
    messageType: string | null;
    shortType: string;
    count: number;
    messages: RabbitMessage[];
}

export async function getVHosts(): Promise<string[]> {
    return api.get('/BackOffice/RabbitMq/VHosts');
}

export async function getErrorQueues(vhost: string): Promise<ErrorQueueSummary[]> {
    return api.get(`/BackOffice/RabbitMq/${encodeURIComponent(vhost)}/ErrorQueues`);
}

export async function peekMessages(vhost: string, queue: string, count: number): Promise<RabbitMessage[]> {
    return api.get(`/BackOffice/RabbitMq/${encodeURIComponent(vhost)}/${encodeURIComponent(queue)}/Messages?count=${count}`);
}

export async function retryByType(vhost: string, queue: string, messageType: string, count: number, targetQueue: string): Promise<{ retried: number }> {
    return api.post(`/BackOffice/RabbitMq/${encodeURIComponent(vhost)}/${encodeURIComponent(queue)}/RetryByType`, { MessageType: messageType, Count: count, TargetQueue: targetQueue });
}

export function groupByType(messages: RabbitMessage[]): MessageTypeGroup[] {
    const map = new Map<string, MessageTypeGroup>();
    for (const msg of messages) {
        const key = msg.MessageType ?? '(unknown)';
        if (!map.has(key)) {
            map.set(key, {
                messageType: msg.MessageType,
                shortType: msg.ShortMessageType ?? key,
                count: 0,
                messages: [],
            });
        }
        const group = map.get(key)!;
        group.count++;
        group.messages.push(msg);
    }
    return [...map.values()].sort((a, b) => b.count - a.count);
}